export type SchoolLevel = 'ala' | 'yla' | 'lukio' | 'ammatillinen';

export const getSchoolLevels = (typeCode: string): SchoolLevel[] => {
    const code = parseInt(typeCode, 10);
    if (!code) return [];
    if (code >= 101 && code <= 119) return ['ala'];
    if (code >= 121 && code <= 129) return ['yla'];
    if (code >= 131 && code <= 139) return ['lukio'];
    if (code === 140 || code === 142 || code === 250 || code >= 997)
        return ['ala', 'yla', 'lukio'];
    if (code === 141 || code === 145) return ['ala'];
    if (code === 143 || code === 146) return ['yla'];
    if (code === 144) return ['lukio'];
    if (code === 210 || code === 211) return ['ammatillinen'];
    if (code >= 200 && code <= 208) {
        if ([201, 203, 205, 207].includes(code)) return ['ala'];
        if ([202, 204, 206, 208].includes(code)) return ['yla', 'lukio'];
        return ['lukio'];
    }
    if (code >= 220) return ['lukio'];
    return [];
};
